export enum CracStatus {
    /*TODO*/
    AVAILABLE = 3,
}
export const CRAC_CONSTANTS = {
    general: {
        path: 'general',
        label: 'Général',
        title: 'Général',
        subTitle: 'CRAC',
        texts: {},
    },
};
